import { createRouter, createWebHistory } from 'vue-router';

import CCM00100 from '../views/CCM00100.vue';
import CMR00100 from '../views/member/CMR00100.vue';
import CMR00200 from '../views/member/CMR00200.vue';
import CPR00100 from '../views/CPR00100.vue';
import BASE from '../views/BASE.vue';
import CTP00100 from '../views/CTP00100.vue';
import CDD00100 from '../views/CDD00100.vue';
import CIQ00100 from '../views/CIQ00100.vue';
import CMI00100 from '../views/member/CMI00100.vue';
import CMI00200 from '../views/member/CMI00200.vue';
import CMI00300 from '../views/member/CMI00300.vue';
import CMI00310 from '../views/member/CMI00310.vue';
import CSR00100 from '../views/CSR00100.vue';
import CSR00200 from '../views/CSR00200.vue';
import COH00100 from '../views/COH00100.vue';
import CMD00011 from '../views/master/CMD00011.vue';
import CMD00100 from '../views/master/CMD00100.vue';
import CMD00110 from '../views/master/CMD00110.vue';
import CMD00200 from '../views/master/CMD00200.vue';
import CMD00300 from '../views/master/CMD00300.vue';
import CMD00400 from '../views/master/CMD00400.vue';
import CMD00410 from '../views/master/CMD00410.vue';
import CMD00500 from '../views/master/CMD00500.vue';
import CMD00510 from '../views/master/CMD00510.vue';
import CMD00600 from '../views/master/CMD00600.vue';
import CMD00610 from '../views/master/CMD00610.vue';
import CMD00700 from '../views/master/CMD00700.vue';
import CMD00710 from '../views/master/CMD00710.vue';
import CMD00711 from '../views/master/CMD00711.vue';
import CMD00720 from '../views/master/CMD00720.vue';
import CMD00800 from '../views/master/CMD00800.vue';
import CMD00810 from '../views/master/CMD00810.vue';
import CMD01000 from '../views/master/CMD01000.vue';
import CMD01010 from '../views/master/CMD01010.vue';
import CMD011001 from '../views/master/CMD01100.vue';
import CMD012001 from '../views/master/CMD01200.vue';
import ERROR from '../views/error/ERROR.vue';

const APP_NAME = 'ChemPanda';
const routes = [
  {
    path: '/login',
    name: 'login',
    component: CCM00100,
    meta: { title: `| ログイン` },
  },
  {
    path: '/Error',
    name: 'error',
    component: ERROR,
  },
  {
    path: '/',
    name: 'BASE',
    component: BASE,
    props: true,
    children: [
      {
        path: '/Top',
        name: 'top',
        component: CTP00100,
        meta: { title: `| TOP` },
      },
      {
        path: '/MemberRegist',
        name: 'memberRegist',
        component: CMR00100,
        props: true,
        meta: { title: `| 新規会員登録` },
      },
      {
        path: '/AdminRegist',
        name: 'adminRegist',
        component: CMR00200,
        props: true,
        meta: { title: `| 新規管理者登録` },
      },
      {
        path: '/PasswordReissue',
        name: 'passwordReissue',
        component: CPR00100,
        props: true,
        meta: { title: `| パスワード再発行依頼` },
      },
      {
        path: '/CatalogData',
        name: 'catalogData',
        component: CDD00100,
        meta: { title: `| カタログデータダウンロード` },
      },
      {
        path: '/Inquiry',
        name: 'inquiry',
        component: CIQ00100,
        meta: { title: `| お問い合わせ` },
      },
      {
        path: '/Memberinfo',
        name: 'memberInfo',
        component: CMI00100,
        props: true,
        meta: { title: `| 会員情報` },
      },
      {
        path: '/Members',
        name: 'members',
        component: CMI00300,
        meta: { title: `| 会員一覧` },
      },
      {
        path: '/MemberinfoUpdate',
        name: 'memberinfoUpdate',
        component: CMI00200,
        props: true,
        meta: { title: `| 会員情報変更` },
      },
      {
        path: '/ApprovalSetting',
        name: 'approvalSetting',
        component: CMI00310,
        props: true,
        meta: { title: `| 承認設定` },
      },
      {
        path: '/OrderInquiry',
        name: 'orderInquiry',
        component: CSR00100,
        meta: { title: `| 注文/問い合わせ` },
      },
      {
        path: '/Search',
        name: 'search',
        component: CSR00200,
        props: true,
        meta: { title: `| 検索` },
      },
      {
        path: '/OrderQuote',
        name: 'orderQuote',
        component: COH00100,
        meta: { title: `| 注文・見積依頼履歴` },
      },
          {
            path: '/MasterMaintenance',
            name: 'masterTop',
            component: CMD00011,
            meta: { title: `| マスターメンテナンス` },
          },
          {
            path: '/MasterMaintenance/Supplier',
            name: 'supplier',
            component: CMD00100,
            meta: { title: `| サプライヤ一覧` },
          },
          {
            path: '/MasterMaintenance/Supplier/Regist',
            name: 'supplierRegist',
            component: CMD00110,
            meta: { title: `| サプライヤ新規登録` },
            props: true,
          },
          {
            path: '/MasterMaintenance/Supplier/Edit',
            name: 'supplierEdit',
            component: CMD00110,
            meta: { title: `| サプライヤ更新` },
            props: true,
          },
          {
            path: '/MasterMaintenance/stockPrice/SetFormat',
            name: 'stockPriceSetFormat',
            component: CMD00200,
            meta: { title: `| 在庫価格ファイル取込フォーマット指定` },
            props: true,
          },
          {
            path: '/MasterMaintenance/stockPrice',
            name: 'stockPrice',
            component: CMD00300,
            meta: { title: `| 在庫価格ファイル取込(CSV)` },

          },
          {
            path: '/MasterMaintenance/Customer',
            name: 'customer',
            component: CMD00400,
            meta: { title: `| 得意先および掛け率一覧` },
          },
          {
            path: '/MasterMaintenance/Customer/Regist',
            name: 'customerRegist',
            component: CMD00410,
            meta: { title: `| 得意先および掛け率新規登録` },
            props: true,
          },
          {
            path: '/MasterMaintenance/Customer/Edit',
            name: 'customerEdit',
            component: CMD00410,
            meta: { title: `| 得意先および掛け率変更` },
            props: true,
          },
          {
            path: '/MasterMaintenance/DeliveryTime',
            name: 'deliveryTime',
            component: CMD00500,
            meta: { title: `| 納期一覧` },
          },
          {
            path: '/MasterMaintenance/DeliveryTime/Register',
            name: 'deliveryTimeRegister',
            component: CMD00510,
            meta: { title: `| 納期新規登録` },
            props: true,
          },
          {
            path: '/MasterMaintenance/DeliveryTime/Edit',
            name: 'deliveryTimeEdit',
            component: CMD00510,
            meta: { title: `| 納期変更` },
            props: true,
          },
          {
            path: '/MasterMaintenance/AttoId',
            name: 'attoId',
            component: CMD00600,
            meta: { title: `| ATTOID一覧` },
          },
          {
            path: '/MasterMaintenance/AttoId/Regist',
            name: 'attoIdRegist',
            component: CMD00610,
            meta: { title: `| ATTOID新規登録` },
          },
          {
            path: '/MasterMaintenance/SDFile',
            name: 'sdfile',
            component: CMD00700,
            meta: { title: `| SDFile一覧` },
          },
          {
            path: '/MasterMaintenance/SDFile/Regist',
            name: 'sdfileRegist',
            component: CMD00710,
            meta: { title: `| SDFile登録` },
          },
          {
            path: '/MasterMaintenance/SDFile/SetFormat',
            name: 'sdfileSetFormat',
            component: CMD00711,
            meta: { title: `| SDFile項目確認` },
            props: true,
          },
          {
            path: '/MasterMaintenance/SDFile/Edit',
            name: 'sdfileEdit',
            component: CMD00720,
            meta: { title: `| SDFile変更` },
            props: true,
          },
          {
            path: '/MasterMaintenance/Catalog',
            name: 'catalog',
            component: CMD00800,
            meta: { title: `| 商品情報一覧` },
          },
          {
            path: '/MasterMaintenance/Catalog/Edit',
            name: 'catalogEdit',
            component: CMD00810,
            meta: { title: `| 商品情報変更` },
            props: true,
          },
          {
            path: '/MasterMaintenance/news',
            name: 'news',
            component: CMD01000,
            meta: { title: `| お知らせ一覧` },
          },
          {
            path: '/MasterMaintenance/news/Register',
            name: 'newsRegister',
            component: CMD01010,
            meta: { title: `| お知らせ新規登録` },
            props: true,
          },
          {
            path: '/MasterMaintenance/news/Edit',
            name: 'newsEdit',
            component: CMD01010,
            meta: { title: `| お知らせ情報変更` },
            props: true,
          },
          {
            path: '/MasterMaintenance/exchangeRate',
            name: 'exchangeRate',
            component: CMD011001,
            meta: { title: `| 為替レート設定` },
            props: true,
          },
          {
            path: '/MasterMaintenance/CoefficientSetting',
            name: 'CoefficientSetting',
            component: CMD012001,
            meta: { title: `| 円転後仕入価格別係数設定` },
            props: true,
          },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
    return { top: 0 };
  },
});
router.afterEach((to) => {
  document.title = to.meta.title ? `${APP_NAME} ${to.meta.title}` : APP_NAME;
});

export default router;
